<template>
  <div class="main container" :class="{ 'search-on': $route.meta.search }">
    <div class="breadcrumbs">
      <template v-for="(i, index) in pathArray">
        <router-link
          class="breadcrumbs__item f15 fw500"
          v-if="
            router.matched[index] &&
            router.matched[index].meta &&
            router.matched[index].meta.breadCrumb
          "
          :key="index"
          :to="
            router.matched[index].path
              .replace(':userId', router.params.userId)
              .replace(':id', router.params.id) || '/'
          "
        >
          {{
            router.matched[index].meta.breadCrumbRouterQuery
              ? router.matched[index].meta.breadCrumb($route.query)
              : router.matched[index].meta.breadCrumbGetter
              ? typeof router.matched[index].meta.breadCrumb == 'function'
                ? $store.getters[router.matched[index].meta.breadCrumbGetter]
                  ? router.matched[index].meta.breadCrumb(
                      $store.getters[router.matched[index].meta.breadCrumbGetter],
                    ) &&
                    router.matched[index].meta.breadCrumb(
                      $store.getters[router.matched[index].meta.breadCrumbGetter],
                    ).length
                    ? router.matched[index].meta.breadCrumb(
                        $store.getters[router.matched[index].meta.breadCrumbGetter],
                      )
                    : localStorage.translations.pages.common.breadcrumbs.loading
                  : ''
                : router.matched[index].meta.breadCrumb
              : router.matched[index].meta.breadCrumbLocalStorage
              ? router.matched[index].meta.breadCrumb(
                  localStorage[router.matched[index].meta.breadCrumbLocalStorage],
                )
              : typeof router.matched[index].meta.breadCrumb == 'function'
              ? (router.matched[index].meta.breadCrumb() || localStorage.translations.pages.common.breadcrumbs.loading)
              : router.matched[index].meta.breadCrumb
          }}
        </router-link>
        <svg
          v-if="
            router.matched[index] &&
            router.matched[index].meta &&
            router.matched[index].meta.breadCrumb
          "
          :key="'svg' + index"
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 12.5L7 7L1 1.5"
            stroke="#B4B4B4"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BreadCrumbs',
  data() {
    return {
      search: '',
      searchLoad: false,
      router: null,
      pathArray: null,
    }
  },
  created() {
    this.updateData()
    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  watch: {
    $route(newData, oldData) {
      this.updateData()
      if (newData.name !== oldData.name) this.search = ''
    },
    search(newData, oldData) {
      if (newData === null || newData === '') {
        this.$routerPushQueryParams('search', '')
      }
    },
  },
  methods: {
    updateData() {
      this.router = this.$router.currentRoute
      this.pathArray = this.$router.currentRoute.path.split('/')
    },
    onSearch() {
      if (!this.searchLoad) {
        this.searchLoad = true
        setTimeout(() => {
          this.$routerPushQueryParams('search', this.search ? this.search : '')
          this.searchLoad = false
        }, 2000)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  display: grid !important;
  align-items: center;
  background-color: #f2f2f2;
  flex-grow: 0 !important;
  &.search-on {
    grid-template-columns: auto 260px;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      grid-template-columns: 1fr;
    }
  }
  .breadcrumbs {
    display: flex;
    flex-wrap: wrap;

    padding: 10px 0;
    align-items: center;
    &__item {
      // margin: -10px 0;
      padding: 10px 0;
      color: #277faf;
      text-decoration: none;
      white-space: nowrap;
      transition: 0.3s;
      &:last-of-type {
        pointer-events: none;
        color: #828282;
      }
      &:hover {
        color: #53b6ee;
      }
    }

    svg {
      margin: 0 12px;
      &:last-of-type {
        display: none;
      }
    }
    .v-input:deep() {
      .v-input__slot {
        margin: 0;
      }
      .v-text-field__details {
        display: none;
      }
      .v-input__icon--append i {
        font-size: 16px;
        transform: rotate(90deg);
        margin-right: 11px;
        color: #b4b4b4;
      }
    }
  }
}
</style>
